import { h } from "@stencil/core";
/* eslint-disable */
export const Cross = (props = null) => (
    <svg {...props} viewBox='0 0 32 32' role='img' fill='currentColor'>
        <path d='M7.776 7.776l-1.152 1.152 7.392 7.392-7.456 7.424 1.12 1.12c0.64 0.64 1.184 1.12 1.248 1.12s1.792-1.632 3.776-3.648l3.68-3.648 7.456 7.456 2.208-2.4-7.36-7.36 7.36-7.392-2.368-2.368-7.36 7.36-7.392-7.36-1.152 1.152'></path>
    </svg>
);
